module.exports = __webpack_public_path__ + "img/pic9.e20da561.png";